export default "__VITE_ASSET__DM64eqWX__"